import { render, staticRenderFns } from "./water.vue?vue&type=template&id=f482d1e6&scoped=true&"
import script from "./water.vue?vue&type=script&lang=js&"
export * from "./water.vue?vue&type=script&lang=js&"
import style0 from "./water.vue?vue&type=style&index=0&id=f482d1e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f482d1e6",
  null
  
)

export default component.exports